import { ScoreLayer } from "./ScoreLayer";
import { PositionLayer } from "./PositionLayer";
import { GameVars } from "../../../../GameVars";
import { PointsLayer } from "./PointsLayer";
import { AI } from "../../AI";
import { BoardScene } from "../../BoardScene";
import { GameConstants } from "../../../../GameConstants";
import { AudioManager } from "../../../../AudioManager";

export class PlayerContainer extends Phaser.GameObjects.Container {

    private passContainer: Phaser.GameObjects.Container;
    private passText: Phaser.GameObjects.Text;
    private passPoints: Phaser.GameObjects.Text;
    private passAvatar: Phaser.GameObjects.Image;
    private stopButton: Phaser.GameObjects.Image;
    private scoreLayer: ScoreLayer;
    private positionLayer: PositionLayer;
    private pointsLayer: PointsLayer;

    private tokens: Phaser.GameObjects.Image[];

    private AI: AI;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.y = 308;
        this.x = 0;

        this.passContainer = new Phaser.GameObjects.Container(this.scene, -360, 300);
        this.passContainer.setAngle(-5);
        this.add(this.passContainer);

        let passBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_language", "player-pass");
        this.passContainer.add(passBackground);

        this.passAvatar = new Phaser.GameObjects.Image(this.scene, -70, 10, "texture_atlas_1");
        this.passAvatar.setScale(.5);
        this.passContainer.add(this.passAvatar);

        this.passText = new Phaser.GameObjects.Text(this.scene, -10, -32, "", {fontFamily: "HelveticaNeue", fontSize: "25px", color: "#FFFFFF"});
        this.passContainer.add(this.passText);

        this.passPoints = new Phaser.GameObjects.Text(this.scene, -15, 20, "", {fontFamily: "HelveticaNeue", fontSize: "30px", color: "#0a2f76"});
        this.passContainer.add(this.passPoints);

        this.tokens = [];

        for (let i = 0; i < 3; i++) {

            let token = new Phaser.GameObjects.Image(this.scene, 
                -80 + 80 * i - 360, 
                70, 
                "texture_atlas_language", "token");
            token.setAngle(Math.random() * 360 - 180);
            token.setAlpha(0);
            token.setScale(2);
            this.add(token);
            this.tokens.push(token);
        }

        this.stopButton = new Phaser.GameObjects.Image(this.scene, 0, -151, "texture_atlas_language", "btn_stop");
        this.stopButton.setInteractive();
        this.stopButton.visible = false;
        this.stopButton.on("pointerdown", this.onStopDown, this);
        this.stopButton.on("pointerover", () => {
            if (GameVars.needStop === -1) {
                this.stopButton.setFrame("btn_stop_hover");
            } else {
                this.stopButton.setFrame("stop_hover");
            }
        }, this);
        this.stopButton.on("pointerup", () => {
            if (GameVars.needStop === -1) {
                this.stopButton.setFrame("btn_stop_hover");
            } else {
                this.stopButton.setFrame("stop_hover");
            }
        }, this);
        this.stopButton.on("pointerout", () => {
            if (GameVars.needStop === -1) {
                this.stopButton.setFrame("btn_stop");
            } else {
                this.stopButton.setFrame("stop");
            }
        }, this);
        this.add(this.stopButton);

        this.scoreLayer = new ScoreLayer(this.scene, 0);
        this.add(this.scoreLayer);

        this.positionLayer = new PositionLayer(this.scene, 0);
        this.add(this.positionLayer);

        this.pointsLayer = new PointsLayer(this.scene, 0);
        this.add(this.pointsLayer);

        this.AI = new AI();
        this.AI.init(0);
    }

    public startGame(): void {

        this.passText.setText(GameVars.players[0].name);
        this.passPoints.setText(GameVars.players[0].points.toString());
        this.passAvatar.setFrame("avatar_" + GameVars.players[0].gender + "_" + GameVars.players[0].avatarId);

        this.scene.tweens.add({
            targets: this.passContainer,
            x: -360,
            y: -40,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 1000,
            duration: 500,
            onStart: () => {
                AudioManager.playSound("cards_out");
            },
            onStartScope: this
        });

        for (let i = 0; i < 3; i++) {
            this.scene.tweens.add({
                targets: this.tokens[i],
                scaleX: 1,
                scaleY: 1,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: 2250 + i * 250,
                duration: 500,
                onStart: () => {
                    AudioManager.playSound("token");
                },
                onStartScope: this
            });
        }

        this.resetAI();
    }

    public showStop(): void {

        // this.AI.log();

        if (GameVars.needStop !== -1 || GameVars.round === 1) {
            return;
        }

        this.stopButton.setFrame("btn_stop");
        this.stopButton.visible = true;
    }

    public hideStop(): void {
        
        this.stopButton.visible = false;
    }

    public showScores(): void {
        
        this.scoreLayer.show();
    }

    public hideScores(): void {
        
        this.scoreLayer.hide();
    }

    public showPosition(): void {

        this.positionLayer.show(); 
    }

    public hidePosition(): void {
        
        this.positionLayer.hide(); 
    }

    public showPoints(): void {
        
        this.pointsLayer.show();
        this.passPoints.setText(GameVars.players[0].points.toString());

        for (let i = 0; i < 3; i++) {
            
            if (GameVars.players[0].tokens < i + 1) {
                if (this.tokens[i].visible) {
                    this.scene.tweens.add({
                        targets: this.tokens[i],
                        alpha: 0,
                        scaleX: 1.5,
                        scaleY: 1.5,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 500,
                        onComplete: () => {
                            this.tokens[i].visible = false;
                        }, 
                        onCompleteScope: this,
                    });
                    AudioManager.playSound("token");
                }
            }
        }
    }

    public resetAI(): void {

        this.AI.reset();
    }

    public addCardToPlayerAI(): void {

        this.AI.addCardToPlayer(GameVars.topCardWaste, GameVars.currentTurn);
    }

    public removeCardToPlayerAI(card: CardValue): void {

        this.AI.removeCardToPlayer(card, GameVars.currentTurn);
    }

    public selectDeckOrWasteAI(): string {

        return this.AI.selectDeckOrWasteAI();
    }

    public selectCardAndStopAI(): {card: number, stop: boolean} {

        return this.AI.selectCardAndStopAI();
    }

    private onStopDown(): void {

        if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 12) {
            BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_3);
            GameVars.tutorialCount = 13;
        }

        if (GameVars.needStop === -1) {
            this.stopButton.setFrame("stop_hover");
            GameVars.needStop = 0;
            AudioManager.playSound("stop_the_bus_bell");
        } else {
            this.stopButton.setFrame("btn_stop_hover");
            GameVars.needStop = -1;
            AudioManager.playSound("cancel_stop");
        }

        this.stopButton.setScale(1); 
    }
}
